/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TemplateIcon = ({ width = 24, height = 24, hidden = false, title = 'Template' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.75,18H5.25c-1.24023,0-2.25-1.00928-2.25-2.25V3.25c0-1.24072,1.00977-2.25,2.25-2.25h9.5c1.24023,0,2.25,1.00928,2.25,2.25v12.5c0,1.24072-1.00977,2.25-2.25,2.25ZM5.25,2.5c-.41309,0-.75.33643-.75.75v12.5c0,.41357.33691.75.75.75h9.5c.41309,0,.75-.33643.75-.75V3.25c0-.41357-.33691-.75-.75-.75H5.25Z"
      fill="currentColor"
    />
    <path
      d="M9.65137,15.2666c-.16992,0-.34375-.03467-.5127-.10742-.5791-.25098-.87305-.85254-.71289-1.46338l.58887-2.21777h-2.13477c-.45215,0-.87012-.24512-1.09082-.63965-.2207-.39404-.21191-.87842.02441-1.26367l3.46777-5.34619c.32129-.52246.95605-.72705,1.54102-.48242.58203.24512.88086.84424.72656,1.45703l-.59863,2.29688h2.16992c.46094,0,.88281.25195,1.10059.6582.21875.40576.19629.89697-.05762,1.28174l-3.48047,5.25195c-.23047.36816-.61914.57471-1.03125.57471ZM9.42773,13.87158c-.00195.00244-.00391.00488-.00488.00732l.00488-.00732ZM7.33984,9.97803h2c.39062,0,.75195.17773.99023.48779.23926.30957.31836.70459.21777,1.08252l-.2793,1.05371,2.38672-3.60205h-2.02832c-.38965,0-.75-.17676-.98828-.48535-.23926-.30859-.32031-.70166-.22168-1.07861l.28711-1.104-2.36426,3.646ZM13.12012,9h.00977-.00977ZM10.54883,5.0293l-.00488.00732c.00195-.00244.00391-.00488.00488-.00732Z"
      fill="currentColor"
    />
  </svg>`;
};
